"use strict";

var _toConsumableArray = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadingReducer = exports.INITIAL_STATE = void 0;

var utils_1 = require("./utils");

exports.INITIAL_STATE = [];

function loadingReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : exports.INITIAL_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var type = utils_1.getType(action); // ie. "Fetch Address Parcels"

  var status = utils_1.getStatus(action); // REQUEST, SUCCESS, FAILURE

  switch (status) {
    case 'REQUEST':
      {
        return [].concat(_toConsumableArray(state), [action]);
      }

    case 'FAILURE':
    case 'SUCCESS':
      {
        return utils_1.removeLast(state, function (actionItem) {
          return utils_1.getType(actionItem) === type;
        });
      }

    default:
      return state;
  }
}

exports.loadingReducer = loadingReducer;